import { mergeObjectEntities } from "src/shared/initializers/typePolicies/helpers/mergeObjectEntities"

export const firmClient = {
  FirmClient: {
    // FirmClient.counts is period/origin-sensitive, but `counts` takes no field
    // args, so normalizing by id would let the table (live origin) and the
    // status-count queries (frozen origin) clobber each other's counts. Opting
    // out of normalization keeps each instance scoped to its own listFirmClients
    // result. Tradeoff: no id-based surgical updates (writeFragment/cache.modify
    // on one row), but nothing does that today — rows only come from
    // listFirmClients, and the period-sensitive counts would make it unsafe.
    keyFields: false as const,
  },
  FirmClientList: {
    fields: {
      entities: {
        merge: mergeObjectEntities,
      },
    },
  },
}
